import Environment from '../models/environment.model';

const LiveUK: Environment = {
  region: 'uk',
  env: 'live',
  timezone: 'Europe/London',
  leapAuth: {
    clientId: 'LSANDMMWVAL4LGCH',
    oauthEndpoint: 'https://login.leap365.co.uk',
    providerId: 'leap',
    userInfoUri: '/api/userinfo',
    authAgentUrl: 'https://cdn.test.leap.com.au/leap_auth/auth_agent/2.0.1/index.umd.js',
  },
  title: 'this is live uk',
  reportingEndpoint: 'https://reporting-api.leapaws.co.uk',
  reportingServiceEndpoint: 'https://reporting-services-api.leapaws.co.uk',

  helpCenterUrl: 'https://community.leap.co.uk/s/',
  powerBILink: 'https://community.leap.co.uk/s/article/Installing-Power-BI-LEAP-Connector-UK',
  articleLinks: [
    {
      label: 'Available LEAP Reports',
      link: 'https://community.leap.co.uk/s/article/Available-LEAP-Reports-UK',
    },
    {
      label: 'About LEAP Reports',
      link: 'https://community.leap.co.uk/s/article/LEAP-Reports-UK',
    },
    {
      label: '10 Essential LEAP Reports',
      link: 'https://community.leap.co.uk/s/article/10-Essential-LEAP-Reports-UK',
    },
    {
      label: 'A Guide on Invoice-Related Reports',
      link: 'https://community.leap.co.uk/s/article/A-Guide-on-Invoices-Related-Reports-UK',
    },
    {
      label: 'LEAP Reports - FAQs',
      link: 'https://community.leap.co.uk/s/article/LEAP-Reports-FAQs-UK',
    },
  ],
};

export default LiveUK;
